export default function(form,formName,store){
    let formIsComplete = null
    let requiredFieldCount = 0
    let validRequiredFieldCount = 0

    form.forEach((field)=>{
        let valid = false
        if (field.validator) {
            valid = field.type === 'select'
                        ? field.validator(field.value, field.options)
                        : field.validator(field.value)
        }

        const compareWith = form.find((compareField)=>{
            return compareField.name === field.compareTo
        })

        if(compareWith){
            valid = !!(valid && compareWith.value === field.value)
        } 

        field.valid = valid
        validRequiredFieldCount = field.valid && field.required ? validRequiredFieldCount+1 : validRequiredFieldCount
        requiredFieldCount = field.required ? requiredFieldCount+1 : requiredFieldCount 
    })

    formIsComplete = requiredFieldCount === validRequiredFieldCount

    store.dispatch('ecom/completeCheckoutForm',{
        name: formName,
        ready: formIsComplete,
        form
    })
    
}